import { Injectable } from '@angular/core'
import { Converter, Occ, Product, VariantOption } from '@spartacus/core'
import {
  VariantOptionToProductLineModelNormalizer
} from '../components/product-line/product-line.component.normalizer'

@Injectable({
  providedIn: 'root'
})
export class ProductNormalizer implements Converter<Occ.Product, Product> {

  constructor (protected productLineModelNormalizer: VariantOptionToProductLineModelNormalizer) {
  }

  convert (source: Occ.Product, target?: Product) {
    const retValue = target && target || {} as Product
    retValue.originalCode = target?.code
    if (source.variantOptions) {
      if (retValue.variantOptions) {
        retValue.variantOptions = retValue.variantOptions.map(variantOption => ({
          ...variantOption,
          productLine: this.productLineModelNormalizer
            .convert(source?.variantOptions?.find(value => value.code === variantOption.code) as VariantOption)
        }))
      } else {
        retValue.variantOptions = source.variantOptions.map(vOption => ({
            productLine: this.productLineModelNormalizer.convert(vOption)
          } as VariantOption)
        )
      }
    }
    return retValue
  }
}
